import React, { Component } from 'react';
import Truncate from 'react-truncate';
import classes from './ListItem.module.css';
import genderAvatarOne from '../../../assets/images/avatar/user-placeholder-gender-one.webp';
import genderAvatarTwo from '../../../assets/images/avatar/user-placeholder-gender-two.webp';
import genderAvatarThree from '../../../assets/images/avatar/user-placeholder-gender-three.webp';
import config from '../../../constants/config';
import {
  getAge,
  getChatDateFormat,
  getMaxDate,
} from '../../../assets/helpers/dateTimeUtils';
import strings from '../../../assets/localization';
import paths from '../../../constants/paths';
import BadgeDot from '../BadgeDot/BadgeDot';
import LazyImage from '../LazyImage/LazyImage';
import Button from '../Button/Button';
import { isUserAdmin } from '../../../assets/helpers/messagesHelper';
import Auxi from '../../../hoc/Auxi/Auxi';

const deepEqual = require('deepequal');

export default class ListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isNameTruncated: false,
    };
  }

  handleNameTruncate = (isTruncated) => {
    if (this.state.isNameTruncated !== isTruncated) {
      this.setState({ isNameTruncated: isTruncated });
    }
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (
      deepEqual(nextProps.user, this.props.user) ||
      deepEqual(nextState, this.state)
    ) {
      return true;
    }
    return false;
  }

  goToPromo = (promoId) => {
    this.props.goToUpgrade(promoId);
  };

  render() {
    // console.log('ListITEM RENDER:', this.props, this.state);

    const { user, currentUser, listItemStyle, showViews, goToMemberProfile } =
      this.props;

    let location;
    const {
      images,
      username,
      first_name,
      dob,
      city,
      state,
      country,
      sex,
      fromChat,
      received_last,
      sent_last,
      unseen,
      unopened,
      online,
      tag_line,
      virtual_chat,
      admin_subtitle,
      user_id,
      last_message_content,
    } = user;
    const chatDateStr = fromChat
      ? getChatDateFormat(getMaxDate(received_last, sent_last))
      : '';

    let userImage;

    if (images && images.length > 0) {
      if (
        typeof images[0] === 'object' &&
        Object.prototype.hasOwnProperty.call(images[0], 'url')
      ) {
        userImage = images[0].url;
      } else if (
        typeof images[0] === 'object' &&
        Object.prototype.hasOwnProperty.call(images[0], 'thumb')
      ) {
        userImage = images[0].thumb;
      } else {
        userImage = images[0];
      }
    } else if (sex === config.GENDER_ONE) {
      userImage = genderAvatarOne;
    } else if (sex === config.GENDER_TWO) {
      userImage = genderAvatarTwo;
    } else {
      userImage = genderAvatarThree;
    }

    if (currentUser.country === 'US' && country === 'US') {
      location = `${city}, ${state}`;
    } else {
      location = `${city}, ${country}`;
    }

    // const photoCount = images && images.length > 0 ? images.length : 0;
    let photoCount = 0;
    let promoContent = null;

    for (let i = 0; i < images.length; i++) {
      if (!images[i].placeholder) {
        photoCount++;
      }
    }

    if (last_message_content && last_message_content.sub_type === 'promo') {
      const { button_text, description, headline, promo_id } =
        last_message_content;
      // console.log(
      //   'BICE PROMO!!!',
      //   {
      //     button_text,
      //     description,
      //     headline,
      //     promo_id,
      //   },
      //   this.props
      // );

      promoContent = (
        <div className={classes.PromoWrapper}>
          <div className={classes.PromoHeadline}>{headline}</div>
          <div className={classes.PromoDescription}>{description}</div>
          <Button
            clicked={(e) => {
              e.preventDefault();
              this.goToPromo(promo_id);
            }}
          >
            {button_text}
          </Button>
        </div>
      );
    }

    let liNameAndAgeCss = fromChat
      ? [classes.ListItemNameAndAge, classes.ListItemNameAndAgeChat].join(' ')
      : classes.ListItemNameAndAge;
    let liNameAndAgeAllCss = unopened
      ? [liNameAndAgeCss, classes.ListItemNameAndAgeUnopened].join(' ')
      : liNameAndAgeCss;
    let renderAge = !virtual_chat ? (
      <span>&nbsp;|&nbsp;{getAge(dob)}</span>
    ) : null;
    return (
      <Auxi>
        <div className={classes.ListItem} style={listItemStyle}>
          <div
            className={classes.ListItemLeft}
            onClick={(e) => {
              if (goToMemberProfile && !isUserAdmin(user_id)) {
                // console.log('KLIKK!!!!!');
                e.preventDefault();
                goToMemberProfile(user_id);
              }
            }}
          >
            <div className={classes.ListItemImageWrapper}>
              <div
                className={classes.ListItemImage}
                style={{
                  borderColor: this.props.user.vip_user ? '#FFA42D' : null,
                }}
              >
                {userImage ? (
                  <LazyImage
                    sex={sex}
                    srcLoaded={userImage}
                    style={{ borderRadius: '50%' }}
                    lazyImgStyle={{ objectFit: 'cover' }}
                    notLazy={this.props.notLazy}
                  />
                ) : (
                  <svg className={classes.IconSvg}>
                    <use xlinkHref='#icon-logo-tiny' />
                  </svg>
                )}
              </div>

              {photoCount > 0 && !fromChat ? (
                <div className={classes.ListItemCameraWrapper}>
                  <svg className={classes.ListItemCameraCount}>
                    <use xlinkHref='/sprites.svg#icon-camera-filled' />
                  </svg>
                  <span className={classes.ListItemCameraCountNumber}>
                    {photoCount}
                  </span>
                </div>
              ) : null}
              <div className={classes.ListItemBadgePosition}>
                <BadgeDot active={online} />
              </div>
              {this.props.user.vip_user ? (
                <div
                  className={classes.ListItemVipBadgeWrapper}
                  style={{
                    backgroundColor: online
                      ? 'var(--online-badge-background)'
                      : 'var(--vip-border-color)',
                  }}
                >
                  <svg className={classes.ListItemVipBadge}>
                    <use xlinkHref='/sprites.svg#vip-member-badge' />
                  </svg>
                </div>
              ) : null}
            </div>
          </div>
          <div className={classes.ListItemRight}>
            <div className={classes.ListItemRightData}>
              <span
                className={liNameAndAgeAllCss}
                title={this.state.isNameTruncated ? first_name || username : ''}
              >
                <span className={classes.ListItemBadgeRedPosition}>
                  <BadgeDot small active={unseen} />
                </span>
                <Truncate
                  lines={1}
                  ellipsis='...'
                  onTruncate={this.handleNameTruncate}
                >
                  {first_name || username}
                </Truncate>
                {renderAge}
              </span>
              <span className={classes.ListItemLocation}>
                {!virtual_chat ? (
                  <Truncate lines={1} ellipsis='...'>
                    {location}
                  </Truncate>
                ) : (
                  admin_subtitle || config.TITLE
                )}
              </span>
              <div className={classes.TagAndBadge}>
                {showViews && user.cnt ? (
                  <span className={classes.ListItemViewedCountTag}>
                    {user.cnt}&nbsp;
                    {user.cnt === 1 ? strings.view : strings.views}
                  </span>
                ) : null}
                <span className={classes.ListItemTagLine}>
                  <Truncate lines={1} ellipsis='...'>
                    {tag_line}
                  </Truncate>
                </span>
              </div>
            </div>
            {fromChat ? (
              <span className={classes.ListItemDate}>{chatDateStr}</span>
            ) : null}
            <svg
              className={classes.ListItemRightArrow}
              style={{ marginTop: fromChat ? '1.25rem' : '0' }}
            >
              <use xlinkHref='/sprites.svg#icon-arrow-right' />
            </svg>
          </div>
        </div>
        {promoContent}
      </Auxi>
    );
  }
}
